import gql from 'graphql-tag';

export default gql`
    query getCreditCard{
        getCreditCardDiscount{
            creditCardDiscount
        }
    }
`;
